export const drawerNames = {
  LOCALES: 'locales',
}

export default {
  drawerNames,
}
